import React from 'react';
import theme from '../../../theme';
import { IGenericIconProps } from './types';

const ArrowCircleUpIcon: React.FC<IGenericIconProps> = ({
    width = 20,
    height = 20,
    strokeWidth = '1.5',
    strokeColor = theme.colors.loopEmerald,
    fill = 'none'
}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill={fill}>
        <circle
            cx="10.0003"
            cy="9.99984"
            r="7.58333"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
        />
        <path
            d="M9.25 14.1665C9.25 14.5807 9.58579 14.9165 10 14.9165C10.4142 14.9165 10.75 14.5807 10.75 14.1665L9.25 14.1665ZM10.5303 6.13617C10.2374 5.84328 9.76256 5.84328 9.46967 6.13617L4.6967 10.9091C4.40381 11.202 4.40381 11.6769 4.6967 11.9698C4.98959 12.2627 5.46447 12.2627 5.75736 11.9698L10 7.72716L14.2426 11.9698C14.5355 12.2627 15.0104 12.2627 15.3033 11.9698C15.5962 11.6769 15.5962 11.202 15.3033 10.9091L10.5303 6.13617ZM10 14.1665L10.75 14.1665L10.75 6.6665L10 6.6665L9.25 6.6665L9.25 14.1665L10 14.1665Z"
            fill={strokeColor}
        />
    </svg>
);

export default ArrowCircleUpIcon;
